/**
 * OnOff Style03 - Stitch v1: 垂直膠囊切換，thumb 隨 ON/OFF 移動
 * OFF: thumb 在底部（深色），icon 為 teal
 * ON: thumb 在頂部（teal），icon 為白
 */
import { useState, useEffect } from 'react'
import type { TraitControlProps } from './types'
import { getDeviceTypeIcon } from './traitStyleConfig'
import './OnOffStyle03.css'

export function OnOffStyle03({
  trait,
  device,
  state,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const traitToken = String(trait || '').trim().toLowerCase()
  const isStartStopTrait = traitToken === 'startstop'
  const icon = getDeviceTypeIcon(device)
  const fromState = Boolean(
    state?.on === true || state?.on === 1 || state?.on === 'on' ||
    state?.OnOff === true || state?.OnOff === 1 || state?.OnOff === 'on' ||
    state?.running === true || state?.running === 1 || state?.running === 'running' || state?.running === 'on' ||
    state?.status === 'running' || state?.status === 'RUNNING'
  )
  const [localOverride, setLocalOverride] = useState<boolean | null>(null)

  useEffect(() => {
    setLocalOverride(null)
  }, [fromState])

  const isOn = localOverride ?? fromState
  const stateToken = isStartStopTrait ? (isOn ? 'on start' : 'off stop') : isOn ? 'on' : 'off'

  const handleToggle = () => {
    if (disabled) return
    const next = !isOn
    setLocalOverride(next)
    if (isStartStopTrait) {
      void onCommand(next ? 'start' : 'stop')
      return
    }
    void onCommand(next ? 'on' : 'off')
  }

  return (
    <div className="trait-onoff-style03 trait-stitch-glass">
      <div
        className={`trait-onoff-style03__track ${disabled ? 'disabled' : ''}`}
        onClick={handleToggle}
        onKeyDown={(e) => e.key === 'Enter' && handleToggle()}
        role="switch"
        aria-checked={isOn}
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : 0}
        data-css-slot="powerTrack"
        data-css-slot-label={isStartStopTrait ? 'StartStop Track' : 'Power Track'}
        data-css-state={stateToken}
      >
        <div
          className={`trait-onoff-style03__thumb ${isOn ? 'on' : 'off'}`}
          style={{
            top: isOn ? 8 : undefined,
            bottom: isOn ? undefined : 8,
          }}
          data-css-slot="powerThumb"
          data-css-slot-label={isStartStopTrait ? 'StartStop Thumb' : 'Power Thumb'}
          data-css-state={stateToken}
        >
          <span
            className={`material-symbols-outlined trait-onoff-style03__icon ${isOn ? 'on' : 'off'}`}
            data-css-slot="powerIcon"
            data-css-slot-label={isStartStopTrait ? 'StartStop Icon' : 'Power Icon'}
            data-css-state={stateToken}
          >
            {icon}
          </span>
        </div>
      </div>
    </div>
  )
}
